var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"gl-mb-6"},[_vm._v(_vm._s(_vm.$options.i18n.title))]),_vm._v(" "),_c('div',{staticClass:"security-charts gl-display-grid"},[_c('vulnerabilities-over-time-chart',{attrs:{"query":_vm.historyQuery}}),_vm._v(" "),_c('vulnerability-severities',{attrs:{"query":_vm.gradesQuery}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }